// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function ButtonPrimary(Props) {
  let title = Props.title;
  let onClick = Props.onClick;
  let iconOpt = Props.icon;
  let reference = Props.reference;
  let disabledOpt = Props.disabled;
  let classNameOpt = Props.className;
  let textSizeOpt = Props.textSize;
  const icon = iconOpt !== undefined ? iconOpt : "";
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const className = classNameOpt !== undefined ? classNameOpt : "px-3 py-2 gap-1";
  const textSize = textSizeOpt !== undefined ? textSizeOpt : "H6";
  let tmp = textSize === "H5" ? JsxRuntime.jsx(Buhta_components__Text.H5.make, {
      className: "text-white",
      children: title
    }) : JsxRuntime.jsx(Buhta_components__Text.H6.make, {
      className: "text-white",
      children: title
    });
  return JsxRuntime.jsxs("button", {
    ref: reference,
    children: [
      tmp,
      icon === "" ? null : JsxRuntime.jsx("img", {
          className: "w-4 h-4",
          alt: "",
          src: icon
        })
    ],
    className: Cn.fromList({
      hd: "bg-links hover:bg-button-primary-hover active:bg-button-primary-active rounded-sm flex items-center disabled:opacity-50 disabled:cursor-not-allowed hover:bg-links-hover active:bg-links-active",
      tl: {
        hd: className,
        tl: /* [] */ 0
      }
    }),
    disabled: disabled,
    onClick: onClick
  });
}

const make = ButtonPrimary;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
